export default __webpack_public_path__ + "static/media/Mimi_Carter_AHV_In_Moms_We_Trust.c834f75e.jpg";